<template>
  <div class="pad-top-25 pad-btm-20">
    <section class="crumbs-container">
      <span v-for="(item, index) in ancestors" :key="`${item.name}-${index}`" :class="{'active': index === ancestors.length - 1 }">
        {{item.name}}
        <span v-if="index !== ancestors.length - 1">&gt; </span>
      </span>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {

    }
  },
  computed: {
    ...mapState('rule', ['getChildrenFn', 'noticeList']),
    ancestors () {
      return [
        {
          name: '首页'
        },
        {
          name: '搜索结果'
        }
      ]
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.crumbs-container {
  font-size: 12px;
  line-height: 14px;
  border-left: 2px solid #F10180;
  color: #333;
  margin-left: -10px;
  padding-left: 10px;
  .active {
    color: #999;
  }
}
</style>
